// @flow
import * as React from 'react'
import type { PropsSchema, EasyAction, BasicProps, JsEnv } from '../../../type'
import computeData from '../../hoc/computeData'
import * as browserEnv from 'frame/core/browserEnv'
import styles from './ScrapingPrize.scss'
type Props = BasicProps & {
  customProps?: {
    $comp: {
      scratchConfig?: {
        centreImage?: {
          url: string
        }
      }
    }
  },
  jsEnv: JsEnv,
  children: React.ChildrenArray<React.Node>,
  callActions: (actionName: string, dynamicData: any) => {},
  centreImage: ?{
    url: string
  }
};

const isMobile =
  browserEnv.isInIOS() || browserEnv.isInAndroid() || browserEnv.isInWeixin()

@computeData({ includeData: true })
export default class extends React.PureComponent<Props> {
  static schema: PropsSchema = [
    {
      type: 'image',
      key: 'centreImage',
      title: '刮中图片'
    },
    'separator',
    {
      type: 'event',
      event: 'finish',
      title: '刮奖完成'
    },
    {
      type: 'event',
      event: 'loadedImg',
      title: '图片加载完成'
    }
  ];
  static actions: EasyAction[] = [
    {
      title: '初始刮刮卡',
      name: 'initScratch'
    }
  ];

  canvas: any;
  currentImg: any;
  getMousePos (event: any) {
    const ele = this.refs.content
    const obj = ele && ele.getBoundingClientRect()
    var e = isMobile ? event.touches[0] : event
    var x = (isMobile ? e.clientX : e.pageX) - obj.left
    var y = (isMobile ? e.clientY : e.pageY) - obj.top
    return { x, y }
  }

  isDisableScroll (flag: boolean) {
    if (isMobile) {
      if (document && document.body) {
        if (flag) {
          document.body.style.position = 'fixed'
          document.body.style.overflow = 'hidden'
        } else {
          document.body.style.position = 'unset'
          document.body.style.overflow = 'unset'
        }
      }
    }
  }

  draw () {
    let _self = this
    let can = this.canvas
    let ctx = can.getContext('2d')
    can.width = _self.currentImg.width
    can.height = _self.currentImg.height
    let pat = ctx.createPattern(_self.currentImg, 'no-repeat')
    ctx.fillStyle = pat || '#ddd'
    ctx.fillRect(0, 0, _self.currentImg.width, _self.currentImg.height)
    ctx.strokeStyle = '#000'
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    ctx.lineWidth = 40
    ctx.globalCompositeOperation = 'destination-out'

    let check = () => {
      let data = ctx.getImageData(0, 0, can.width, can.height).data
      let n = 0
      for (let i = 0; i < data.length; i += 4) {
        if (
          data[i] === 0 &&
          data[i + 1] === 0 &&
          data[i + 2] === 0 &&
          data[i + 3] === 0
        ) {
          n++
        }
      }
      let f = (n * 100) / (can.width * can.height)
      if (f > 60) {
        ctx.beginPath()
        ctx.fillRect(0, 0, can.width, can.height)
        this.props.callActions('finish')
        endFun()
        can.removeEventListener(start, startFun)
      }
    }
    function addHandler (element, type, handler) {
      if (element.addEventListener) {
        element.addEventListener(type, handler, false)
      } else {
        element['on' + type] = handler
      }
    }

    var move = isMobile ? 'touchmove' : 'mousemove'
    var start = isMobile ? 'touchstart' : 'mousedown'
    var end = isMobile ? 'touchend' : 'mouseup'
    let startx = 0
    let starty = 0
    let startFun = function (e) {
      _self.isDisableScroll(true)
      let mousePos = _self.getMousePos(e)
      startx = mousePos.x
      starty = mousePos.y
      ctx.beginPath()
      ctx.fill()
      addHandler(can, move, moveFun)
      addHandler(can, end, endFun)
    }
    let moveFun = function (e) {
      let mousePos = _self.getMousePos(e)
      let endx = mousePos.x
      let endy = mousePos.y
      ctx.moveTo(startx, starty)
      ctx.lineTo(endx, endy)
      startx = endx
      starty = endy
      ctx.stroke()
      check()
    }
    let endFun = function () {
      // 抬起后将事件注销
      can.removeEventListener(move, moveFun)
      can.removeEventListener(end, endFun)
      _self.isDisableScroll(false)
    }
    addHandler(can, start, startFun)
  }
  actionInitScratch = () => {
    this.draw()
  };
  componentDidMount () {
    let { centreImage, jsEnv, customProps = {} } = this.props
    let scratchConfig =
      customProps.$comp && customProps.$comp.scratchConfig
        ? customProps.$comp.scratchConfig
        : {}
    centreImage = centreImage || scratchConfig.centreImage || {}
    let centreImageUrl = jsEnv.getString(centreImage.url || '')
    let img = this.refs.centreImg
    img.crossOrigin = ''
    let _this = this
    img.onload = function () {
      _this.currentImg = this
      _this.draw()
      _this.props.callActions('loadedImg')
    }
    img.src = centreImageUrl
  }
  render () {
    return (
      <div ref='content' className={`${styles.this}`}>
        <img
          ref='centreImg'
          style={{ width: '100%', height: '100%', opacity: 0 }}
        />
        <canvas ref={ref => (this.canvas = ref)} />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/projects/easy/public/Comps/ui/Draw/ScrapingPrize.js